import { Box, FormLabel, Heading } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import ButtonBack from "components/ui/ButtonBack";
import CheckboxSelect from "components/ui/CheckboxSelect/CheckboxSelect";
import { useStepperContext } from "components/ui/custom-stepper/CustomStepperContext";
import FilterGroup from "components/ui/FilterGroup";
import FixedBar from "components/ui/FixedBar";
import SubmitButton from "components/ui/SubmitButton";
import { useSuccessDialogContext } from "components/ui/SuccessDialog/SuccessDialogContext";
import SearchProvider from "contexts/SearchContext";
import { useCreateListData } from "features/lists/contexts/CreateListDataContext";
import { useMessages } from "hooks/useMessages";
import { useResourceList } from "hooks/useResourceList";
import { ArrayRequiredTestFunction } from "lib/validation";
import { useState } from "react";
import {
  FormProvider,
  Resolver,
  SubmitHandler,
  useForm,
} from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useSaveList } from "../../hooks/useSaveList";
import SearchResultMembers from "../SearchResultMembers";
import RecipientsByCompanies from "./RecipientsByCompanies";

interface FormValues {
  recipients: [];
}

const validationSchema = Yup.object().shape({
  recipients: Yup.mixed().test("recipients", "", ArrayRequiredTestFunction),
});

export default function FormCreateListMembers() {
  const { data: companies } = useResourceList({
    resourceName: "companies",
  });
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const { previouStep } = useStepperContext();
  const { data, onSubmitData } = useCreateListData();
  const navigate = useNavigate();
  const { openSuccessDialog } = useSuccessDialogContext();

  const methods = useForm<FormValues>({
    mode: "all",
    resolver: yupResolver(validationSchema) as unknown as Resolver<FormValues>,
    defaultValues: data,
  });

  const {
    handleSubmit,
    formState: { isValid },
  } = methods;
  const { onError } = useMessages();

  const { onSaveList, isPending } = useSaveList({
    onSuccess: ({ data }) => {
      navigate("/listas-de-disparo");
      openSuccessDialog({
        title: "Nova lista cadastrada!",
        description: '',
        actionButtonText: "Criar mais uma lista",
        actionButton: "/listas-de-disparo/nova",
        closeButtonText: "Tudo certo",
      });
    },
    onError: (error) => onError(error?.response?.data?.message),
  });

  const onSubmit: SubmitHandler<FormValues> = (values) => {
    onSubmitData(values);
    onSaveList({ ...data, ...values });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Heading as="h1" size="h1">
          Membros da lista
          <span>Selecione os membros dentro da base de clientes Patri</span>
        </Heading>

        <SearchProvider
          searchKey="recipients"
          searchPath="/recipients"
          searchMode="query"
          urlParamKey="membersQ"
        >
          <FilterGroup
            mt="40px"
            pos="relative"
            direction={{ base: "column", md: "row" }}
          >
            <Box flex={1}>
              <SearchResultMembers />
            </Box>
            <Box>
              <FormLabel>Filtrar por cliente</FormLabel>
              <CheckboxSelect
                placeholder="Todos os clientes"
                options={companies?.map((c) => ({
                  value: c.id,
                  label: c.name,
                }))}
                onChange={(value) =>
                  setCompanyOptions(value.map((v) => v.value))
                }
              />
            </Box>
          </FilterGroup>
        </SearchProvider>

        <RecipientsByCompanies companyIds={companyOptions} />

        <FixedBar>
          <ButtonBack onClick={previouStep} />

          <SubmitButton
            isDisabled={isPending || !isValid}
            isLoading={isPending}
            hideIcon
          >
            Criar lista
          </SubmitButton>
        </FixedBar>
      </form>
    </FormProvider>
  );
}
